import React from "react";
import * as FaIcons from "react-icons/fa";

const R14HealthConditions = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const {
    firstName,
    knownHealthConditions,
    asthma,
    beeStingAllergy,
    diabetes,
    epilepsy,
    heartCondition,
    seizures,
    nutAllergy,
    knownHearingConditions,
    wearsHearingAid,
    knownEyeCondition,
    glassesToBeWornAtAllTimes,
    wearsContactLenses,
    wearsGlasses,
    medications,
    otherHealthCondition,
    medicalInstructions,
    heathInsuranceCarrier,
    insuranceIdOrPolicyNumber,
    hospitalPreference,
  } = formData;
  return (
    <>
      {/* Health Conditions */}
      <div className="sub-form">
        <h3>Health Conditions</h3>
        {/* Conditions which may result in a classroom emergency  */}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Does {firstName === "" ? "the Student" : firstName} have any known
              Health Conditions?{" "}
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(knownHealthConditions["yes"] || knownHealthConditions["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={knownHealthConditions["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHealthConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={knownHealthConditions["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHealthConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {knownHealthConditions["yes"] && (
          <div className="options-flex">
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Asthma </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck && !(asthma["yes"] || asthma["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={asthma["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="asthma"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={asthma["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="asthma"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Bee Sting Allergy </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !(beeStingAllergy["yes"] || beeStingAllergy["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={beeStingAllergy["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="beeStingAllergy"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={beeStingAllergy["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="beeStingAllergy"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Diabetes </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck && !(diabetes["yes"] || diabetes["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={diabetes["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="diabetes"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={diabetes["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="diabetes"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Epilepsy </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck && !(epilepsy["yes"] || epilepsy["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={epilepsy["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="epilepsy"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={epilepsy["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="epilepsy"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Heart Condition </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !(heartCondition["yes"] || heartCondition["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={heartCondition["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="heartCondition"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={heartCondition["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="heartCondition"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Seizures </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck && !(seizures["yes"] || seizures["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={seizures["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="seizures"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={seizures["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="seizures"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>Nut Allergy</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck && !(nutAllergy["yes"] || nutAllergy["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={nutAllergy["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="nutAllergy"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={nutAllergy["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="nutAllergy"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        )}

        {/* Conditions Which Affect Hearing */}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Does {firstName === "" ? "the Student" : firstName} have any known
              Hearing Problems?{" "}
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(knownHearingConditions["yes"] || knownHearingConditions["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={knownHearingConditions["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHearingConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={knownHearingConditions["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownHearingConditions"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        {knownHearingConditions["yes"] && (
          <div className="sum-item">
            <div className="asterisk-group">
              <h4>
                Does {firstName === "" ? "the Student" : firstName} wear a
                Hearing Aid
              </h4>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border:
                  validationCheck &&
                  !(wearsHearingAid["yes"] || wearsHearingAid["no"])
                    ? "2px solid #d8302f"
                    : "",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={wearsHearingAid["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="wearsHearingAid"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={wearsHearingAid["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="wearsHearingAid"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
        )}
        {/* Conditions Which Affect Vision */}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Does {firstName === "" ? "the Student" : firstName} have any known
              Eye Conditions?{" "}
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(knownEyeCondition["yes"] || knownEyeCondition["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={knownEyeCondition["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownEyeCondition"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={knownEyeCondition["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="knownEyeCondition"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {knownEyeCondition["yes"] && (
          <div className="options-flex">
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  Does {firstName === "" ? "the Student" : firstName} need
                  glasses to be worn at all times{" "}
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !(
                      glassesToBeWornAtAllTimes["yes"] ||
                      glassesToBeWornAtAllTimes["no"]
                    )
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={glassesToBeWornAtAllTimes["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="glassesToBeWornAtAllTimes"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={glassesToBeWornAtAllTimes["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="glassesToBeWornAtAllTimes"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  Does {firstName === "" ? "the Student" : firstName} Wear
                  Contact Lenses
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !(wearsContactLenses["yes"] || wearsContactLenses["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={wearsContactLenses["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="wearsContactLenses"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={wearsContactLenses["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="wearsContactLenses"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  Does {firstName === "" ? "the Student" : firstName} Wear
                  Glasses
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !(wearsGlasses["yes"] || wearsGlasses["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={wearsGlasses["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="wearsGlasses"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={wearsGlasses["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="wearsGlasses"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        )}

        {/* Health Information */}
        <div className="sum-item">
          <h4>
            Does {firstName === "" ? "the Student" : firstName} have any
            Medications?
          </h4>
          <input
            type="text"
            name="medications"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={medications}
          />
        </div>

        <div className="sum-item">
          <h4>
            Does {firstName === "" ? "the Student" : firstName} have any Other
            Health Condition?
          </h4>
          <input
            type="text"
            name="otherHealthCondition"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={otherHealthCondition}
          />
        </div>

        <div className="sum-item">
          <h4>
            Does {firstName === "" ? "the Student" : firstName} have any Medical
            Instructions?
          </h4>
          <input
            type="text"
            name="medicalInstructions"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={medicalInstructions}
          />
        </div>
        {/* Insurance */}
        <div className="sum-item">
          <h4>
            What is {firstName === "" ? "the Student" : firstName}'s Heath
            Insurance Carrier?
          </h4>
          {/* <div className="asterisk-group">
            <h4>What is {firstName === "" ? 'the Student' : firstName}'s Heath Insurance Carrier?</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div> */}
          <input
            type="text"
            name="heathInsuranceCarrier"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={heathInsuranceCarrier}
          />
        </div>

        <div className="sum-item">
          <h4>
            What is {firstName === "" ? "the Student" : firstName}'s Insurance
            ID or Policy #?
          </h4>
          {/* <div className="asterisk-group">
            <h4>What is {firstName === "" ? 'the Student' : firstName}'s Insurance ID or Policy #?</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div> */}
          <input
            type="text"
            name="insuranceIdOrPolicyNumber"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={insuranceIdOrPolicyNumber}
          />
        </div>

        <div className="sum-item">
          <h4>
            What is {firstName === "" ? "the Student" : firstName}'s Hospital
            Preference?
          </h4>
          {/* <div className="asterisk-group">
            <h4>What is {firstName === "" ? 'the Student' : firstName}'s Hospital Preference?</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div> */}
          <input
            type="text"
            name="hospitalPreference"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={hospitalPreference}
          />
        </div>
      </div>
    </>
  );
};

export default R14HealthConditions;
